/**
 * 公共接口
 */
import http from '../http';
import Qs from 'qs';

// 登录
const doLogin = (params) =>
  http
    .post('/admin/mini_auth/login', Qs.stringify(params))
    .then((res) => res.data);

// 登出
const doLogout = (params) =>
  http.get('/admin/mini_auth/logout', { params }).then((res) => res.data);

// 基础库
// 获取年级列表
const getGrades = (params) =>
  http.get('/sysGrades/school/grades', { params }).then((res) => res.data);

// v1.3.1 查询学校的年级和班级
const getListOrgGradeClass = (params) =>
  http.get('/sysGrades/listOrgGradeClass', { params }).then((res) => res.data);
// v1.3.1获取年级列表
const getGradesNew = (params) =>
  http.get('/class/listClass', { params }).then((res) => res.data);
// v1.3.1导出学生列表
const exportStudentList = (params) =>
  http
    .get('/student/exportStudentList', { params, responseType: 'blob' })
    .then((res) => res);
// v1.3.1导出离校学生列表
const exportGraduateStudent = (params) =>
  http
    .get('/student/exportGraduateStudent', { params, responseType: 'blob' })
    .then((res) => res);
// v1.3.1离校生学生列表
const getListByGraduateStudent = (params) =>
  http.get('/student/listByGraduateStudent', { params }).then((res) => res.data);
// 获取班级列表
const getClasses = (params) =>
  http.get('/class/school/classes', { params }).then((res) => res.data);

// 获取学期列表
const getListTerms = (params) =>
  http.get('/yearTerms/listTerms', { params }).then((res) => res.data);

// 获取教师列表 v1.3.3
const getTeacherListNew = (params) =>
  http.get('/teacher/allUserList', { params }).then((res) => res.data);

// 获取验证码
const getMsgCode = (params) =>
  http
    .post(`/user/sendMsg`, Qs.stringify(params), {
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
    })
    .then((res) => res.data);
// 获取验证码 - PC
const sendPCMsg = (params) =>
  http
    .post(`/user/sendPCMsg`, Qs.stringify(params), {
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
    })
    .then((res) => res.data);
// PC端：获取验证码（未登录）
const sendMsgToPcLogin = (params) =>
  http
    .post('/user/sendMsgToPcLogin', params, {
      headers: { 'Content-Type': 'application/json' }
    })
    .then((res) => res.data);
// PC端：用户短信登录
const phoneCodeToPcLogin = (params) =>
  http
    .post('/user/phone', params, {
      headers: { 'Content-Type': 'application/json' }
    })
    .then((res) => res.data);

// 查询菜单
const getMenuList = (params) =>
  http.get('/auth/menu', { params }).then((res) => res.data);

const getAccount = (params) =>
  http.get('/user/account', { params }).then((res) => res.data);

// 获取学生列表(根据学校ID)
const getStudentQuerylist = (params) =>
  http.get('/student/querylist', { params }).then((res) => res.data);

// 运营查机构
const organByOpe = (params) =>
  http
    .get('/sysOrganizations/listOrganizationsNew', { params })
    .then((res) => res.data);

// 运营查学校
const schByOpe = (params) =>
  http.get('/sysSchools/listSchoolsNew', { params }).then((res) => res.data);

// 运营查学年学期
const getYearTermDict = (params) =>
  http.get('/sysYearTerm/getYearTermDict', { params }).then((res) => res.data);

// 多端- 数据概览
const getPortDataApi = (params) =>
  http
    .get('/theUserIdentity/dataStatistics/workTableOverView', { params })
    .then((res) => res.data);

// 校验当前登录人手机号
const checkCurrentUserLoginPhoneApi = (params) =>
  http.get('/user/sendLoginMsg', { params }).then((res) => res.data);

// 获取学期列表
const getUserInfoApi = (params) =>
  http.get('/user', { params }).then((res) => res.data);

// 教务人员管理分页查询
const getAcademicStaffApi = (params) =>
  http
    .get('/theUserIdentity/academicStaff/page', { params })
    .then((res) => res.data);

// 查询商品分账规则是否必填
const getGoodsRuleIsRequiredApi = (params) =>
  http.get('/userOrder/isOutMchPayMode', { params }).then((res) => res.data);

// 判断是否有权限集
const getAuthcheckPermissionSets = (params) =>
  http
    .post('/auth/checkAppPermissionSets', params, {
      headers: { 'Content-Type': 'application/json' }
    })
    .then((res) => res.data);

// 获取学校地区编码
const getListAreaCodeApi = (params) =>
  http.get('/sysSchools/listAreaCode', { params }).then((res) => res.data);

// 获取IP地址
const getIpAddr = (params) =>
  http.get('/common/getIpAddr', { params }).then((res) => res.data);

// 获取年度学期列表
const getSysYearTermList = (params) =>
  http.get('/sysYearTerm/getYearTermList', { params }).then((res) => res.data);
// 新增当前学年学期
const addYearTerm = (params) =>
  http
    .post('/admin/sysYearTerm/addYearTerm', params, {
      headers: { 'Content-Type': 'application/json' }
    })
    .then((res) => res.data);
// 编辑当前学年学期
const updateYearTerm = (params) =>
  http
    .post('/admin/sysYearTerm/updateYearTerm', params, {
      headers: { 'Content-Type': 'application/json' }
    })
    .then((res) => res.data);

// 校验是否可添加编辑当前学年学期
const checkYearTerm = (params) =>
  http
    .post('/admin/sysYearTerm/checkYearTerm', params, {
      headers: { 'Content-Type': 'application/json' }
    })
    .then((res) => res.data);
// 获取当前学期
const getPresentYearTerm = (params) =>
  http
    .get('/sysYearTerm/getPresentYearTerm', {
      params
    })
    .then((res) => res.data);

// 获取单位分账规则
const getConfigRelList = (params) =>
  http
    .get('/divideConfig/configRelList', {
      params
    })
    .then((res) => res.data);
// 获取老师列表
const getTeachersList = (params) =>
  http
    .get('/theUserIdentity/dataSearch/searchTeachers', {
      params
    })
    .then((res) => res.data);
// 设置自动退款配置
const setAutoRefundApi = (params) =>
  http
    .post('/theUserIdentity/sysStaticDatas/setAutoRefund', params, {
      headers: { 'Content-Type': 'application/json' }
    })
    .then((res) => res.data);

// 设置自动退款配置
const batchSaveAutoRefundApi = (params) =>
  http
    .post('/theUserIdentity/sysStaticDatas/batchSaveAutoRefund', params, {
      headers: { 'Content-Type': 'application/json' }
    })
    .then((res) => res.data);
// 获取自动退款配置
const getAutoRefundDtoApi = (params) =>
  http
    .get('/theUserIdentity/sysStaticDatas/getAutoRefundDtoBySchoolId', {
      params
    })
    .then((res) => res.data);

// 获取机构服务地区
const getListAreaByOrgIdApi = (params) =>
  http.get('/courseClass/listAreaByOrgId', { params }).then((res) => res.data);

// 获取预览文件token
const getPreviewToken = (params) =>
  http.get('/file/preview/token', { params }).then((res) => res.data);

// 获取单位系统配置
const getListOrgInfoApi = (params) =>
  http
    .get('/theUserIdentity/sysStaticDatas/listOrg', { params })
    .then((res) => res.data);

// 更新单位编码
const updateSchoolCodeApi = (params) =>
  http
    .post(
      `/theUserIdentity/sysStaticDatas/updateSchoolCode`,
      Qs.stringify(params),
      {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
      }
    )
    .then((res) => res.data);

// 更新绑定时间
const updateLimitTimeApi = (params) =>
  http
    .post(
      `/theUserIdentity/sysStaticDatas/updateLimitTime`,
      Qs.stringify(params),
      {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
      }
    )
    .then((res) => res.data);

// 更新绑定限制条件
const updateLimitConditionApi = (params) =>
  http
    .post(
      `/theUserIdentity/sysStaticDatas/updateLimitCondition`,
      Qs.stringify(params),
      {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
      }
    )
    .then((res) => res.data);

// 查询结算单审批流程配置
const getConfigureSettlementApprovalProcess = (params) =>
  http
    .get('/common/getConfigureSettlementApprovalProcess', {
      params
    })
    .then((res) => res.data);

// 通用配置接口 获取用户协议隐私政策
const getConfigDocumentApi = (params) =>
  http
    .get('/common/getUserProtocol', {
      params
    })
    .then((res) => res.data);

// 通用配置接口 配置用户协议隐私政策
const setConfigDocumentApi = (params) =>
  http
    .post('/admin/sysStaticDatas/saveConfig', params, {
      headers: { 'Content-Type': 'application/json' }
    })
    .then((res) => res.data);

// 分页查询课后机构
const getKhOrgListApi = (params) =>
  http
    .get('/theUserIdentity/khOrg/page', {
      params
    })
    .then((res) => res.data);

// 新增课后机构
const addKhOrgListApi = (params) =>
  http
    .post('/theUserIdentity/khOrg/addOrg', params, {
      headers: { 'Content-Type': 'application/json' }
    })
    .then((res) => res.data);

// 编辑课后机构
const updateOrgApi = (params) =>
  http
    .post('/theUserIdentity/khOrg/updateOrg', params, {
      headers: { 'Content-Type': 'application/json' }
    })
    .then((res) => res.data);

// 删除课后机构
const delOrgApi = (params) =>
  http
    .post('/theUserIdentity/khOrg/delOrg', params, {
      headers: { 'Content-Type': 'application/json' }
    })
    .then((res) => res.data);

// 分页查询挂靠信息
const getHangingInfoListApi = (params) =>
  http
    .get('/theUserIdentity/hangingInfo/page', {
      params
    })
    .then((res) => res.data);

// 新增挂靠信息
const addHangingInfoApi = (params) =>
  http
    .post('/theUserIdentity/hangingInfo/addHangingInfo', params, {
      headers: { 'Content-Type': 'application/json' }
    })
    .then((res) => res.data);

// 编辑挂靠信息
const updateHangingInfoApi = (params) =>
  http
    .post('/theUserIdentity/hangingInfo/updateHangingInfo', params, {
      headers: { 'Content-Type': 'application/json' }
    })
    .then((res) => res.data);

// 删除挂靠信息
const delHangingInfoApi = (params) =>
  http
    .post('/theUserIdentity/hangingInfo/delHangingInfo', params, {
      headers: { 'Content-Type': 'application/json' }
    })
    .then((res) => res.data);

// 导出挂靠信息
const exportHangingInfoApi = (params) =>
  http
    .get('/theUserIdentity/hangingInfo/export', {
      params,
      responseType: 'blob'
    })
    .then((res) => res);

// 分页查询挂靠分账规则
const getHangingDivideRulesListApi = (params) =>
  http
    .get('/theUserIdentity/hangingDivideRules/page', {
      params
    })
    .then((res) => res.data);

// 添加挂靠分账规则
const addRuleApi = (params) =>
  http
    .post('/theUserIdentity/hangingDivideRules/addRule', params, {
      headers: { 'Content-Type': 'application/json' }
    })
    .then((res) => res.data);

// 编辑挂靠分账规则
const updateRuleApi = (params) =>
  http
    .post('/theUserIdentity/hangingDivideRules/updateRule', params, {
      headers: { 'Content-Type': 'application/json' }
    })
    .then((res) => res.data);

// 删除挂靠分账规则
const delRuleApi = (params) =>
  http
    .post('/theUserIdentity/hangingDivideRules/delRule', params, {
      headers: { 'Content-Type': 'application/json' }
    })
    .then((res) => res.data);

export default {
  getAutoRefundDtoApi,
  setAutoRefundApi,
  batchSaveAutoRefundApi,
  doLogin,
  doLogout,
  getGrades,
  getClasses,
  getListTerms,
  getMsgCode,
  sendPCMsg,
  sendMsgToPcLogin,
  phoneCodeToPcLogin,
  getMenuList,
  getGradesNew,
  getTeacherListNew,
  getListOrgGradeClass,
  getListByGraduateStudent,
  exportStudentList,
  exportGraduateStudent,
  getAccount,
  organByOpe,
  schByOpe,
  getStudentQuerylist,
  getPortDataApi,
  checkCurrentUserLoginPhoneApi,
  getUserInfoApi,
  getAcademicStaffApi,
  getGoodsRuleIsRequiredApi,
  getListAreaCodeApi,
  getAuthcheckPermissionSets,
  getIpAddr,
  getYearTermDict,
  getSysYearTermList,
  addYearTerm,
  updateYearTerm,
  checkYearTerm,
  getPresentYearTerm,
  getConfigRelList,
  getTeachersList,
  getListAreaByOrgIdApi,
  getPreviewToken,
  updateSchoolCodeApi,
  getListOrgInfoApi,
  updateLimitTimeApi,
  updateLimitConditionApi,
  getConfigureSettlementApprovalProcess,
  getConfigDocumentApi,
  setConfigDocumentApi,
  getKhOrgListApi,
  addKhOrgListApi,
  updateOrgApi,
  delOrgApi,
  getHangingInfoListApi,
  addHangingInfoApi,
  updateHangingInfoApi,
  delHangingInfoApi,
  exportHangingInfoApi,
  getHangingDivideRulesListApi,
  addRuleApi,
  updateRuleApi,
  delRuleApi
};
